import loadable from 'utils/loadable.jsx';

export default loadable(() => import('./index.js'), {
  fallback: null,
});
